/*
  Defaults for api setup.
*/

// import * as cancelation from './middleware/cancelation';
import { ModuleObject } from '../types';
import { METHODS } from './method_conventions/base';
import transport from './transports/fetch';
import { ApiMethod, Middlewares, RequestConfig } from './types';
import { deepFreeze } from './utils';

export const DEFAULT_BASE_URL = '';

export const DEFAULT_MIDDLEWARE: Middlewares = deepFreeze({
  request: [], // [cancelation.requestMiddleware],
  response: [], // [cancelation.responseMiddleware],
});

export const DEFAULT_TRANSPORT = transport;

export interface DefaultRequestConfig extends RequestConfig {
  cancelKey?: string;
  date?: number;
}

export type DEFAULT_API_METHOD = ApiMethod;

export type DEFAULT_METHODS<ModuleT extends ModuleObject> = METHODS<ModuleT>;
